import { Checklist } from './checklist';
import { Customer } from './customer';
import { Deserializable } from './deserializable';
import { Operation } from './operation';
import { SpeechSegment } from './speechSegment';

export class Segment implements Deserializable {
  id: number;
  name: string;
  description: string;
  customerId: number;

  customer: Customer;
  operations: Operation[];
  speechEnvironmentId: any;
  speechEnvironmentName: string;
  speechSegmentId: any;
  speechSegments: SpeechSegment[];
  checklists: Checklist[];

  speechIntegrationActive: boolean;

  selected?: boolean;

  active: boolean = true;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
